import { TableChairIcon } from './TableChairIcon';

/**
 * author: Michael Richins
 * id 6EB52FC2-32D9-427D-80DE-32C60C8F78AD
 * name table-chair
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-chair.svg
 * tags
 * - Home Automation 
 */
export const DiningRoomIcon = TableChairIcon;
export default DiningRoomIcon